var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.generateClass},[_c('div',{staticClass:"mb-4"})])
}
var staticRenderFns = []

export { render, staticRenderFns }